import { type RootState } from '@/store';

export const dashboardData = ({ dashboard: { dashboardData } }: RootState) =>
  dashboardData;
